import { MenuItemType, User } from '@/types';
import { useAuthStore } from '@/stores';

interface UserWithExtras extends User {
    resellProducts?: unknown[];
}

export function filterMenuItems(user: User | null, allItems: MenuItemType[]) {
    if (!user) {
        return { appItems: [], adminItems: [], accountItems: [] };
    }

    const typedUser = user as UserWithExtras;
    const accountScopesInclude = useAuthStore.getState().accountScopesInclude;

    const items = allItems.filter(menu => {
        // If menu has scopes defined, user must have at least one of them
        if (menu.scopes && menu.scopes.length > 0) {
            if (!accountScopesInclude(menu.scopes)) {
                return false;
            }
        }

        // 2. Affiliate check (specific business logic)
        if (menu.route === '/affiliate') {
            return typedUser.has_affiliate_links === true;
        }

        // For now, we are keeping the logic simple to ensure items render.
        // We can re-introduce module/tag/experiment checks later if needed.
        let showMenu = true;

        if (menu.experiments && menu.experiments.length > 0) {
            showMenu = false;
            for (let i = 0, len = menu.experiments.length; i < len; i++) {
                const experimentKey = menu.experiments[i];
                if (experimentKey && user.experiments?.[experimentKey] === 1) {
                    showMenu = true;
                }
            }
        }

        const availableModules = user.subscription_tier_allowed_modules;

        if (menu.moduleName) {
            if (availableModules.indexOf(menu.moduleName) !== -1) {
                showMenu = true;
            } else {
                showMenu = false;
            }
        } else if (availableModules.indexOf('general-modules') === -1) {
            showMenu = false;
        }
        return showMenu;
    });

    return {
        appItems: items.filter(menu => menu.type === 'menu' && menu.position === 'top'),
        adminItems: items.filter(menu => menu.scopes && menu.scopes.length > 0 && menu.position === 'top'),
        accountItems: items.filter(menu => menu.type === 'menu' && menu.position === 'bottom'),
    };
}
